<ng-template #cmsItemLoop let-items="items" let-template="template">
  <ng-container *ngFor="let childContent of items">
    <ng-container
      *ngTemplateOutlet="
        cmsTemplateWrapper;
        context: {
          content: childContent,
          contentObservable: childContent | finToObservable,
          template: template,
        }
      "
    />
  </ng-container>
</ng-template>

<ng-template
  #cmsTemplateWrapper
  let-content="content"
  let-contentObservable="contentObservable"
  let-template="template"
>
  @if (content.contentLocale) {
    <div [attr.lang]="content.contentLocale" class="semantic-wrapper">
      <ng-container
        *ngTemplateOutlet="
          cmsTemplate;
          context: {
            content: content,
            contentObservable: contentObservable,
            template: template,
          }
        "
      />
    </div>
  } @else {
    <ng-container
      *ngTemplateOutlet="
        cmsTemplate;
        context: {
          content: content,
          contentObservable: contentObservable,
          template: template,
        }
      "
    />
  }
</ng-template>

<ng-template #cmsTemplate let-content="content" let-contentObservable="contentObservable" let-template="template">
  @switch (content.contentType) {
    @case (DOCTYPE.CMTeaser) {
      <ng-container *finShowForLoginStatus="content.showForLoginStatus">
        <ng-container *finShowForProfileTiers="content.showForProfileTiers">
          @switch (content.viewType) {
            @case (VIEWTYPE.TEXT_ON_IMAGE) {
              <cms-text-on-image class="col-1-12 md-col-5-12 pr-xsmall-b" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.CTA_WITH_IMAGE_AND_TEXT) {
              <cms-cta-with-image-and-text
                [attr.data-testid]="content.localSettings?.dataTestId"
                [content$]="contentObservable"
                [ngClass]="content.gridClass || 'col-1-12'"
                class="mr-large-b"
              />
            }
            @case (VIEWTYPE.CTA_BIG_LINK) {
              <cms-cta-big-link class="section-two-thirds-right" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.CTA_LINK) {
              <cms-cta-link
                class="section-two-thirds-right"
                [attr.data-testid]="content.localSettings?.dataTestId"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.LINK_BLOCK) {
              <cms-link-block [class]="content.gridClass || 'col-1-12 md-col-5-12'" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.TEXT_LINK) {
              <cms-text-link [class]="content.gridClass || 'col-1-12 md-col-5-12'" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.HERO) {
              <cms-destination-hero class="col-1-12 md-col-5-12" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.FULL_WIDTH_BOOKING_WIDGET) {
              <cms-full-width-booking-widget
                [backgroundImage]="content?.picture || content?.destination?.picture"
                [locations]="[
                  {
                    destinationLocationCode: content?.destination?.defaultLocation?.locationCode,
                  },
                ]"
                [enableAward]="content?.localSettings?.enableAward"
                [enablePromoCode]="content?.localSettings?.enablePromoCode"
                [enableAurinkomatkat]="content?.localSettings?.enableAurinkomatkat"
                [initialTripType]="content.localSettings.initialTripType"
                [ngClass]="content.gridClass"
              />
            }
            @case (VIEWTYPE.HORIZONTAL_TITLE) {
              <cms-horizontal-title
                [ngClass]="content.gridClass || 'col-1-12 md-col-2-11'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.DISCLAIMER) {
              <cms-disclaimer class="col-1-12 md-col-5-12 pr-xsmall-b" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.ITEMS) {
              <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.items, template: template }" />
            }
            @case (VIEWTYPE.DECORATED_HEADING) {
              <cms-teaser
                [attr.data-testid]="content.localSettings?.dataTestId"
                [class]="'section-full-width mr-xlarge-t'"
                [ngClass]="{
                  'decorated-heading': !content?.subjectTaxonomyTags.includes(TAXONOMY.NO_SECTION_MARKER),
                }"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.MAIN_ARTICLE) {
              <cms-teaser
                [attr.data-testid]="content.localSettings?.dataTestId"
                class="mr-small-t"
                [ngClass]="content.gridClass || 'col-1-12'"
                [headerLevel]="1"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.BACK_LINK) {
              <cms-back-link [ngClass]="content.gridClass || 'col-1-12'" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.RETRIEVE_PAGE_CONTENT) {
              <fin-render-lazy-component
                [attr.data-testid]="content.localSettings?.dataTestId"
                [viewType]="VIEWTYPE.RETRIEVE_PAGE_CONTENT"
                [class]="'col-1-12'"
              />
            }
            @case (VIEWTYPE.CHAT_BUTTON) {
              <cms-chat-deeplink
                [ngClass]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content]="content.teaserTitle"
              />
            }
            @case (VIEWTYPE.DESTINATION_FLIGHT_INFO) {
              <cms-destination-flight-info [ngClass]="content.gridClass || 'col-1-12'" />
            }
            @case (VIEWTYPE.CALENDAR_SCHEDULE) {
              <cms-calendar-schedule [ngClass]="content.gridClass || 'col-1-12'" />
            }
            @case (VIEWTYPE.OND_CROSSLINKING_SUGGESTED) {
              <cms-ond-marketing-cross-linking-suggested [ngClass]="content.gridClass || 'col-1-12'" />
            }
            @case (VIEWTYPE.OND_ROUTE_LINKS) {
              <cms-ond-marketing-route-links-full-width />
            }
            @default {
              <cms-teaser
                [attr.data-testid]="content.localSettings?.dataTestId"
                [content$]="contentObservable"
                [ngClass]="content.gridClass || 'col-1-12 md-col-5-12'"
                class="mr-small-t"
              />
            }
          }
        </ng-container>
      </ng-container>
    }

    @case (DOCTYPE.FIMenuFoodItem) {
      <cms-teaser
        [attr.data-testid]="content.localSettings?.dataTestId"
        [class]="content.gridClass || 'col-1-12 md-col-5-12'"
        [content$]="contentObservable"
      />
    }
    @case (DOCTYPE.CMArticle) {
      <ng-container *finShowForLoginStatus="content.showForLoginStatus">
        <ng-container *finShowForProfileTiers="content.showForProfileTiers">
          @switch (content.viewType) {
            @case (VIEWTYPE.TRAVEL_GUIDE) {
              <cms-travel-guide [class]="content.gridClass || 'col-1-12'" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.COLLAPSE_RELATED_CONTENT) {
              <cms-rich-text
                [attr.data-testid]="content.localSettings?.dataTestId"
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
              <cms-show-more>
                <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.media, template: template }" />
                <ng-container
                  *ngTemplateOutlet="cmsItemLoop; context: { items: content.related, template: template }"
                />
              </cms-show-more>
            }
            @case (VIEWTYPE.ICON_WITH_TEXT) {
              <cms-icon-with-text
                [attr.data-testid]="content.localSettings?.dataTestId"
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.TEXT_WITH_SIDE_IMAGE) {
              <cms-text-with-side-image
                [class]="content.gridClass || 'col-1-12 md-col-2-11'"
                [content$]="contentObservable"
                [imageLeft]="isImageLeft(content)"
              />
            }
            @case (VIEWTYPE.MAIN_ARTICLE) {
              <cms-rich-text
                class="mr-small-t"
                [attr.data-testid]="content.localSettings?.dataTestId"
                [ngClass]="content.gridClass || 'col-1-12'"
                [headerLevel]="1"
                [content$]="contentObservable"
              />
              <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.media, template: template }" />
              <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.related, template: template }" />
            }
            @case (VIEWTYPE.BLUEWINGS_CLUSTER_HERO) {
              <fin-hero-bluewings-cluster [content]="content" />
            }
            @case (VIEWTYPE.BLUEWINGS_ARTICLE) {
              <fin-article-bluewings [content]="content" class="col-1-12 md-col-1-8 ms-xsmall-b mr-small-t" />
            }
            @case (VIEWTYPE.CHILD_ARTICLE) {
              <fin-article-child [content]="content" class="col-1-12 md-col-1-8 ms-xsmall-b" />
            }
            @case (VIEWTYPE.DESTINATION_SEARCH_HERO) {
              <fin-render-lazy-component
                [attr.data-testid]="content.localSettings?.dataTestId"
                [viewType]="content.viewType"
                [content]="content"
                [ngClass]="content.gridClass || 'col-1-12'"
                class="fill block grey-25-bg bg-primary"
              />
            }
            @case (VIEWTYPE.EMERGENCY_IN_OPERATIONS_ARTICLE) {
              <fin-emergency-in-operations-article [content]="content" />
            }
            @default {
              <cms-rich-text
                class="mr-small-t"
                [attr.data-testid]="content.localSettings?.dataTestId"
                [ngClass]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
              <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.media, template: template }" />
              <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.related, template: template }" />
            }
          }
        </ng-container>
      </ng-container>
    }

    @case (DOCTYPE.FICategory) {
      @switch (content.viewType) {
        @default {
          <fin-destination-category-hero class="col-1-12 md-col-1-12 mr-small-b" [content]="content" />
          <cms-destination-category-list class="col-1-12 md-col-1-12" [offers]="content.children" />
        }
      }
    }

    @case (DOCTYPE.CMExternalLink) {
      @switch (content.viewType) {
        @default {
          <cms-external-link class="col-1-12 md-col-5-12 mr-medium-t mr-small-b" [content$]="contentObservable" />
        }
      }
    }

    @case (DOCTYPE.CMCollection) {
      <ng-container *finShowForLoginStatus="content.showForLoginStatus">
        <ng-container *finShowForProfileTiers="content.showForProfileTiers">
          @switch (content.viewType) {
            @case (VIEWTYPE.QUICK_LINKS) {
              <cms-quick-links class="col-1-12 md-col-2-11" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.MARKETING_ACTIVITY_BLOCKS) {
              <cms-marketing-activity-blocks
                [ngClass]="content.gridClass || 'col-1-12'"
                class="mr-small-b"
                [content]="content"
              />
            }
            @case (VIEWTYPE.ARTICLE_COLLECTION) {
              <cms-article-collection
                [content$]="contentObservable"
                [ngClass]="content.gridClass || 'col-1-12 md-col-2-10'"
              />
            }
            @case (VIEWTYPE.OFFERS_GRID) {
              <cms-offers-grid class="col-1-12 md-col-2-11" [content]="content" />
            }
            @case (VIEWTYPE.COLLECTION_CONTENT_IN_GRID_LAYOUT) {
              <div class="content-in-grid-layout-collection grid-col-12 grid-max-width no-row-gap">
                <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.items, template: template }" />
              </div>
            }
            @case (VIEWTYPE.TRENDING_DESTINATIONS) {
              <fin-trending-destinations-grid class="col-1-12 md-col-2-11" [content]="content" />
            }
            @case (VIEWTYPE.SHOW_MORE) {
              <cms-show-more class="col-1-12 md-col-5-12">
                <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.items, template: template }" />
              </cms-show-more>
            }
            @case (VIEWTYPE.BADGE) {
              <cms-badge class="col-1-12 md-col-5-12" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.ACCORDION) {
              <cms-accordion [class]="content.gridClass || 'col-1-12 md-col-5-12'" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.ACCORDION_WITH_PICTURES) {
              <cms-accordion
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
                [withPictures]="true"
              />
            }
            @case (VIEWTYPE.CONDITIONAL_ACCORDION) {
              <cms-conditional-accordion
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.CONTENT_DROPDOWN) {
              <cms-content-switcher-dropdown
                class="mr-large-t"
                [ngClass]="content.gridClass || 'col-1-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.CONTENT_TABS) {
              <cms-content-switcher-tabs
                class="mr-large-t"
                [ngClass]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.UNIQUE_SELLING_POINT) {
              <cms-unique-selling-point class="col-1-12 md-col-2-11" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.OND_FAQS) {
              <cms-ond-faqs [ngClass]="content.gridClass || 'col-1-12'" class="mr-small-b" [content]="content" />
            }
            <!-- Rendered separately inside BookingEntryComponent - until someone figures out how to render these there -->
            @case (VIEWTYPE.FRONT_PAGE_DISRUPTIONS) {}
            @case (VIEWTYPE.DISRUPTIONS) {}
            @case (VIEWTYPE.FRONT_PAGE_LINKS) {
              <cms-important-links
                [attr.data-testid]="content.localSettings?.dataTestId"
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.FRONT_PAGE_ARTICLES) {
              <cms-discover-now class="col-1-12 md-col-2-11" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.LINK_LIST_WITH_ICONS) {
              <cms-link-list-with-icons
                [class]="content.gridClass || 'col-1-12 md-col-9-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.ARTICLES_WITH_ICONS) {
              <cms-articles-with-icons [class]="content.gridClass" [content$]="contentObservable" class="mr-small-b" />
            }
            @case (VIEWTYPE.DESCRIPTIVE_LINK_LIST) {
              <cms-descriptive-link-list [class]="content.gridClass || 'col-1-12'" [content$]="contentObservable" />
            }
            @case (VIEWTYPE.LIST_WITH_ICONS) {
              <cms-list-with-icons
                [attr.data-testid]="content.localSettings?.dataTestId"
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
                [useTeaserTitle]="true"
              />
            }
            @case (VIEWTYPE.LIST_WITH_ICONS_TEASERTEXT) {
              <cms-list-with-icons
                [attr.data-testid]="content.localSettings?.dataTestId"
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
                [useTeaserTitle]="false"
              />
            }
            @case (VIEWTYPE.LIST_WITH_HEADING) {
              <cms-list-with-heading
                [class]="content.gridClass || 'col-1-12 md-col-2-11'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.HIGHLIGHT_LIST) {
              <fin-editorial-category
                [class]="content.gridClass || 'col-1-12 md-col-span-6'"
                [editorialCategory]="content"
              />
            }
            @case (VIEWTYPE.COLLECTION_ARROW_LINKS) {
              <cms-arrow-link-list
                [class]="content.gridClass || 'col-1-12 mr-xlarge-b'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.TEASER_LIST) {
              <fin-teaser-list
                [attr.data-testid]="content.localSettings?.dataTestId"
                [content$]="contentObservable"
                class="col-1-12 mr-xlarge-b"
              />
            }
            @case (VIEWTYPE.INFORMATIONAL_TEASER) {
              <fin-informational-teaser
                class="col-1-12"
                [attr.data-testid]="content.localSettings?.dataTestId"
                [informationalTeaser]="content"
              />
            }
            @case (VIEWTYPE.RADIO_COLLECTION) {
              <fin-radio-list
                class="col-1-12"
                [attr.data-testid]="content.localSettings?.dataTestId"
                [content$]="contentObservable"
              />
            }
            @default {
              @if (content.teaserTitle) {
                <h2 class="col-1-12 md-col-5-12" class="nordic-blue-900-text text-icon-primary mr-xxsmall-x">
                  {{ content.teaserTitle }}
                </h2>
              }
              @if (content.gridClass) {
                <div [class]="content.gridClass">
                  <ng-container
                    *ngTemplateOutlet="cmsItemLoop; context: { items: content.items, template: template }"
                  />
                </div>
              } @else {
                <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.items, template: template }" />
              }
            }
          }
        </ng-container>
      </ng-container>
    }

    @case (DOCTYPE.CMPersonalized) {
      @switch (content.viewType) {
        @case (VIEWTYPE.MARKETING_ACTIVITY_BLOCKS) {
          <cms-marketing-activity-blocks class="col-1-12 md-col-2-11" [content]="content" />
        }
        @default {
          <ng-container *ngTemplateOutlet="cmsItemLoop; context: { items: content.items, template: template }" />
        }
      }
    }

    @case (DOCTYPE.CMQueryList) {
      @switch (content.viewType) {
        @case (VIEWTYPE.TEASER_LIST) {
          <fin-teaser-list
            class="mr-xlarge-b"
            [class]="content.gridClass || 'col-1-12'"
            [content$]="contentObservable"
          />
        }
        @default {
          <fin-editorial-category [class]="content.gridClass || 'col-1-12'" [editorialCategory]="content" />
        }
      }
    }

    @case (DOCTYPE.CMRelated) {
      @switch (content.viewType) {
        @case (VIEWTYPE.TAG_LIST) {
          <div class="col-1-12 flex flex--wrap g-small gc-clear ms-large-b">
            @for (tag of content.items; track $index; let i = $index) {
              <fin-article-tag [content]="tag" [templateTags]="templateTaxonomyTags$ | async" />
            }
          </div>
        }
        @case (VIEWTYPE.RELATED_LIST) {
          <fin-related-teaser class="col-1-12 md-col-1-8 mr-xlarge-b" [relatedTeaser]="content" />
        }
        @case (VIEWTYPE.TEASER_LIST) {
          <cms-cmrelated class="col-1-12 mr-small-b" [content]="content" />
        }
        @case (VIEWTYPE.BLUEWINGS_FILTER_CHIPS) {
          <cms-cmrelated
            class="col-1-12 mr-xlarge-b"
            [chipsOnly]="true"
            [content]="content"
            [templateTags]="templateTaxonomyTags$ | async"
          />
        }
        @default {
          <fin-editorial-category [class]="content.gridClass || 'col-1-12'" [editorialCategory]="content" />
        }
      }
    }

    @case (DOCTYPE.FIOffer) {
      @switch (content.viewType) {
        @case (VIEWTYPE.FRONT_PAGE_OFFER) {
          <!-- Do not render FrontPageOffer. Offer is rendered as HeroOffer inside BookingWidget. -->
        }
        @default {
          <cms-teaser [class]="content.gridClass || 'col-1-12 md-col-5-12'" [content$]="contentObservable" />
        }
      }
    }

    @case (DOCTYPE.CMPlaceholder) {
      <ng-container *finShowForLoginStatus="content.showForLoginStatus">
        <ng-container *finShowForProfileTiers="content.showForProfileTiers">
          @switch (content.viewType) {
            @case (VIEWTYPE.HORIZONTAL_RULER) {
              <!-- hr is legacy and should not be used in future content, still present in old content -->
              <hr class="pr-xxsmall-y mr-xxsmall-x mr-large-y" />
            }
            @case (VIEWTYPE.OND_OFFERS) {
              <cms-ond-marketing-offers
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.MMB_REFUND_WIDGET) {
              <fin-mmb-refund-form-component [class]="content.gridClass || 'col-1-12 md-col-5-12'" />
            }
            @case (VIEWTYPE.OND_OFFERS_LIST) {
              <cms-ond-marketing-offers-list
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.BLUEWINGS_ARTICLE_LIST) {
              <fin-bluewings-search-api [class]="content.gridClass || 'col-1-12 md-col-5-12'" [content]="content" />
            }
            @case (VIEWTYPE.BLUEWINGS_MAIN_PAGE_ARTICLE_LIST) {
              <fin-bluewings-main-page class="col-1-12" [content]="content" />
            }
            @case (VIEWTYPE.OND_CROSSLINKING) {
              <cms-ond-marketing-cross-linking
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
                [content$]="contentObservable"
              />
            }
            @case (VIEWTYPE.DESTINATIONS_SEARCH) {
              <fin-render-lazy-component
                [attr.data-testid]="content.localSettings?.dataTestId"
                [viewType]="content.viewType"
                [content]="content"
                [content$]="contentObservable"
                [template]="template"
                class="fill block grey-25-bg bg-primary"
              />
            }
            @case (VIEWTYPE.TRAVEL_RESTRICTIONS) {
              <fin-travel-restrictions class="fill block mr-small-t col-1-12 md-col-2-11" />
            }
            @case (VIEWTYPE.NEWSLETTER_SIGNUP_FORM) {
              <fin-newsletter-signup-form [class]="content.gridClass || 'grid-col-12 grid-max-width no-row-gap'" />
            }
            @case (
              [
                VIEWTYPE.CASE_ATTACHMENT_FORM,
                VIEWTYPE.CORPORATE_CONTACT_FORM,
                VIEWTYPE.GIFT_CARD_INFORMATION_FORM,
                VIEWTYPE.JOIN_CORPORATE_FORM,
                VIEWTYPE.SAF_DOWNLOADABLE_FORM,
                VIEWTYPE.VAT_RECEIPT_FORM,
              ].includes(content.viewType)
                ? content.viewType
                : ''
            ) {
              <fin-render-lazy-component
                [attr.data-testid]="content.localSettings?.dataTestId"
                [template]="template"
                [viewType]="content.viewType"
                class="col-1-12 md-col-2-9 xl-col-2-7"
              />
            }
            @case (VIEWTYPE.LOCATION_BANNER) {
              <!-- Handled below, outside of the status/tiers gated switch -->
            }
            @default {
              <fin-render-lazy-component
                [attr.data-testid]="content.localSettings?.dataTestId"
                [template]="template"
                [viewType]="content.viewType"
                [class]="content.gridClass || 'col-1-12 md-col-5-12'"
              />
            }
          }
        </ng-container>
      </ng-container>
      @switch (content.viewType) {
        @case (VIEWTYPE.LOCATION_BANNER) {
          <cms-book-now class="col-1-12 md-col-1-8 article-offer" [locationCode]="content.locationCode" />
        }
      }
    }

    @case (DOCTYPE.CMVideo) {
      <fin-video
        [class]="content.gridClass || 'col-1-12 md-col-5-12 mr-xlarge-b'"
        [videoUrl$]="contentObservable | finMap: 'dataUrl'"
        [videoTitle$]="contentObservable | finMap: 'teaserTitle'"
      />
    }
  }
</ng-template>

<!-- ROOT -->
<ng-container [ngSwitch]="pageViewType$ | async">
  <ng-container *ngSwitchCase="'section-page-with-title'">
    <div class="top-heading col-1-12 mr-medium-b" *ngIf="(showSideTitle$ | async) === false && (title$ | async)">
      <h1 class="main-page-heading">{{ title$ | async }}</h1>
    </div>
    <!-- SECTION NAVI -->
    <fin-section-navi
      [title]="title$ | async"
      [showTitle]="showSideTitle$ | async"
      class="col-1-12 md-col-1-4"
      [class.disruptions-visible]="disruptions$ | async"
    />
    <cms-disruptions
      *ngIf="disruptions$ | async"
      class="col-1-12 md-col-5-12 ms-xxsmall-y"
      [showLevelOne]="true"
      [disruptions]="disruptions$ | async"
    />
    <ng-container *ngFor="let content of template$ | finMap: 'main' | async">
      <ng-container
        *ngTemplateOutlet="
          cmsTemplateWrapper;
          context: {
            content: content,
            contentObservable: content | finToObservable,
            template: template$ | async,
          }
        "
      />
    </ng-container>
    <!-- /SECTION NAVI -->
  </ng-container>
  <ng-container *ngSwitchDefault>
    <!-- DEFAULT -->
    <cms-disruptions
      *ngIf="disruptions$ | async"
      class="col-1-12 mr-xxsmall-b mr-small-t"
      [showLevelOne]="true"
      [disruptions]="disruptions$ | async"
    />
    <ng-container *ngFor="let content of template$ | finMap: 'main' | async">
      <ng-container
        *ngTemplateOutlet="
          cmsTemplateWrapper;
          context: {
            content: content,
            contentObservable: content | finToObservable,
            template: template$ | async,
          }
        "
      />
    </ng-container>
    <!-- /DEFAULT -->
  </ng-container>
</ng-container>
